import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import TextArea from 'modules/core/components/TextArea'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
  onSubmit: (reason?: string) => void
  authorFullName: string
  targetFullName: string
}

const ConfirmRejectModal = ({ onClose, onSubmit, authorFullName, targetFullName }: Props) => {
  const [rejectionReason, setRejectionReason] = React.useState<string | undefined>()

  return (
    <Modal
      illustration="alert"
      title={i18n.t('contract_versions.modals.reject_promote_request.title')}
      description={i18n.t('contract_versions.modals.reject_promote_request.description', {
        authorFullName: authorFullName,
        targetFullName: targetFullName,
      })}
      onClose={onClose}
      onSubmit={() => onSubmit(rejectionReason)}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{i18n.t('contract_versions.modals.reject_promote_request.submit')}</Button>
        </>
      }
    >
      <Box gap="s24">
        <TextArea
          label={i18n.t('contract_versions.modals.reject_promote_request.reason.label')}
          value={rejectionReason}
          onChange={(value: string) => setRejectionReason(value)}
          placeholder={i18n.t('contract_versions.modals.reject_promote_request.reason.placeholder')}
        />
      </Box>
    </Modal>
  )
}

export default ConfirmRejectModal
